import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';

import { navigateInternally } from 'utils/bolt/index';
import { getDynamicData, transformPageData } from 'utils/bolt/dynamicData';
import parseQueryString from 'utils/parseQueryString';

export default class BoltApp extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();

		const { previewDataPath } = parseQueryString();
		await this.loadFilmPages(previewDataPath);
		Store.get().set({ dynamicDataLoaded: true });
	}

	async loadFilmPages(previewDataPath) {
		const data = await getDynamicData('film-pages');
		const pages = Object.values(data || {}).flatMap(transformPageData);
		Store.get().appData.pages.set(Object.fromEntries(pages.map(p => [p.id, p]))).now();
		const desiredPage = data[previewDataPath]?.url;
		if (desiredPage) {
			navigateInternally(desiredPage);
		}
	}
}
